import React from 'react'
import { IconProps } from '../../../common/types'

const EditNew: React.FC<IconProps> = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 20 16"
      fill="#000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-PencilSimple">
        <path
          id="Vector"
          d="M14.8568 4.58561L12.0643 1.79249C11.9714 1.6996 11.8612 1.62592 11.7398 1.57565C11.6185 1.52539 11.4884 1.49951 11.3571 1.49951C11.2258 1.49951 11.0957 1.52539 10.9744 1.57565C10.853 1.62592 10.7428 1.6996 10.6499 1.79249L2.94303 9.49999C2.84977 9.59251 2.77583 9.70265 2.72551 9.824C2.67519 9.94535 2.64949 10.0755 2.64991 10.2069V13C2.64991 13.2652 2.75526 13.5196 2.9428 13.7071C3.13034 13.8946 3.38469 14 3.64991 14H6.44303C6.5744 14.0004 6.70455 13.9747 6.8259 13.9244C6.94725 13.8741 7.05739 13.8001 7.14991 13.7069L14.8568 5.99999C14.9497 5.90712 15.0233 5.79687 15.0736 5.67553C15.1239 5.55419 15.1498 5.42414 15.1498 5.2928C15.1498 5.16146 15.1239 5.0314 15.0736 4.91006C15.0233 4.78872 14.9497 4.67847 14.8568 4.58561ZM6.44303 13H3.64991V10.2069L9.14991 4.70686L11.943 7.49999L6.44303 13ZM12.6499 6.79249L9.85678 3.99999L11.3568 2.49999L14.1499 5.29249L12.6499 6.79249Z"
          fill="#000"
        />
      </g>
    </svg>
  )
}

export default EditNew
